/**
 * CSS selector for focusable elements.
 * Matches: links with href, enabled buttons, and elements with valid tabindex.
 */
const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Finds and returns the first focusable element within a container.
 * Focusable elements include links with href, enabled buttons, and elements with valid tabindex.
 *
 * @param container - The container element to search within. Can be null or undefined.
 * @returns The first focusable element, or null if none found.
 */
export const getFocusableElement = (container: HTMLElement | null | undefined): HTMLElement | null => {
  if (!container) return null;
  return container.querySelector<HTMLElement>(FOCUSABLE_SELECTOR) ?? null;
};
